import AntdConfigProvider from 'providers/AntdConfigProvider/AntdConfigProvider'
import { CollectionYearProvider } from 'providers/CollectionYearProvider/CollectionYearProvider'
import I18nProvider from 'providers/I18nProvider/I18nProvider'
import { combineProviders } from 'providers/ProvidersCombiner/ProvidersCombiner'
import ReactQueryProvider from 'providers/ReactQueryProvider/ReactQueryProvider'
import ThemeProvider from 'providers/ThemeProvider/ThemeProvider'

const providers = [
    ThemeProvider,
    I18nProvider,
    CollectionYearProvider,
    AntdConfigProvider,
    ReactQueryProvider,
]

export const AppContextProvider = combineProviders(...providers)
